<template>
    <h1>
        没有这个路径,请检查。
    </h1>
</template>

<script>
    import {Component,Vue} from 'vue-property-decorator'
    @Component
    export default class Notfound extends Vue {

    }
</script>

<style lang='scss' scoped>
    h1{
        color: #333333;
    }
</style>
